/**
 * Shared UserEmailField Component
 * Displays user email as plain text, with fallback for missing values
 * Used in ChatSessionList, ImportantDateList, SuggestionList, and similar views
 */

import { useRecordContext } from 'react-admin';
import { Typography } from '@mui/material';

export function UserEmailField({ label: _label }: { label?: string } = {}) {
  const record = useRecordContext();
  if (!record?.userEmail) {
    return <Typography variant="body2" color="textSecondary">-</Typography>;
  }
  return <Typography variant="body2">{record.userEmail}</Typography>;
}
